<template>
  <authenticated-layout :back-route="{
                          name: 'cohortDashboard',
                          params: { cohortId, institutionId, tab: 'licenses' }
                        }"
                        :breadcrumbs="breadcrumbItems">
    <AccessCodeDetailContent
      @access-code-loaded="onAccessCodeLoaded"
    />
  </authenticated-layout>
</template>

<script setup lang="ts">
import {onMounted, ref, computed} from "vue";
import {AccessCode, Cohort} from "@YenzaCT/sdk";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import AccessCodeDetailContent from "@/components/AccessCodeDetail/AccessCodeDetailContent.vue";

import yapi from "@/lib/yapi";
import {useApiCall} from "@/composables/useApiCall";
import {useRoute} from "vue-router";
import {useGlobalStore} from "@/store";

const route = useRoute();
const { executeApi } = useApiCall();
const store = useGlobalStore();

const institutionId = route.params.institutionId as string;
const cohortId = route.params.cohortId as string;
const canAccessSpecificTenant = store.canAccessSpecificTenant(route.params.tenantId as string);

const accessCode = ref<AccessCode>();
const cohort = ref<Cohort>();

const breadcrumbItems = computed(() => [
  { text: "My Schools", to: { name: "schoolsDashboard" } },
  { text: cohort.value?.tenantMeta?.title || "",
    to: canAccessSpecificTenant ? { name: "schoolsDashboardWithTenant",
      params: { tenantId: cohort.value?.tenant } } : {
      name: "schoolsDashboardWithoutTenant"
    }},
  {
    text: cohort.value?.title || "Institution",
    to: { name: "institutionDashboard", params: { institutionId: institutionId } }
  },
  { text: accessCode.value?.code ? `License #${accessCode.value.code}` : "License Details" }
]);

async function fetchInstitutionAndCohort() {
  const result = await executeApi(async () => {
    const response = await yapi.admin.cohort.get(cohortId);
    return response.data;
  });
  if (result) {
    cohort.value = result;
  }
}

function onAccessCodeLoaded(loadedAccessCode: AccessCode) {
  accessCode.value = loadedAccessCode;
}

onMounted(async () => {
  await fetchInstitutionAndCohort();
});
</script>
